module.exports = __webpack_public_path__ + "img/user-alerts.16fcd9ac.svg";